@if(isAuthenticated$ | async ) {
<div
  class="p-4"
  style="display: flex; justify-content: space-between; align-items: center"
>
  <img src="./../assets/terabase-tools.svg" />
  <button tbs-button tbsType="ghost" (click)="logout()">Logout</button>
</div>
<router-outlet></router-outlet>
} @else { Loading... }
